import React, { useState, useEffect } from "react";
// import Applications from "./Applications";
import { useDispatch, useSelector } from "react-redux";
import { getJobNoAuthAction } from "../../../redux/actions/jobActions";
//import {Helmet} from "react-helmet";
//import MetaTags from 'react-meta-tags';
//import DocumentMeta from 'react-document-meta';
//import ShareLink from 'react-linkedin-share-link'

import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  FacebookIcon,
  TwitterIcon,
  LinkedinIcon,
  WhatsappShareButton,
  WhatsappIcon,
} from "react-share";
// import MyJobs from './MyJobs';
import "./details.scss";
import { useParams } from "react-router-dom";

const JobListPublicDetails = () => {
  const { refLink } = useParams();

  const [applyLink, setApplyLink] = useState(null);
  const [originalURL, setOriginalURL] = useState(null);
  const [hasUpdatedMetaTag, setHasUpdatedMetaTag] = useState(false);

  const dispatch = useDispatch();
  const { jobreadonly } = useSelector(({ job }) => job);
  const hashtags = ["workbrook", "job", "workbrookjobs"];

  // Enhanced structured JSON for better Google Jobs integration
  const structuredJSON = JSON.stringify({
    "@context": "https://schema.org/",
    "@type": "JobPosting",
    title: jobreadonly.role_title,
    description: jobreadonly.about_company,
    identifier: {
      "@type": "PropertyValue",
      name: jobreadonly.campany_name || "Workbrook",
      value: jobreadonly.id || "1234567",
    },
    datePosted: jobreadonly.date_created,
    employmentType: jobreadonly.job_type || "FULL_TIME",
    hiringOrganization: {
      "@type": "Organization",
      name: jobreadonly.campany_name || "Workbrook",
      sameAs: process.env.REACT_APP_WEB_URL || "https://workbrook.com",
      logo: "https://web.workbrook.com/favicon.ico",
    },
    jobLocation: {
      "@type": "Place",
      address: {
        "@type": "PostalAddress",
        streetAddress: jobreadonly.location,
        addressLocality: jobreadonly.location,
        addressRegion: "NG",
        postalCode: "10002",
        addressCountry: "NG",
      },
    },
    baseSalary: {
      "@type": "MonetaryAmount",
      currency: "NGN",
      value: {
        "@type": "QuantitativeValue",
        value: jobreadonly.salary,
        unitText: "YEAR",
      },
    },
    industry: jobreadonly.industry,
    skills: jobreadonly.skills_required || [],
    url: window.location.href,
  });

  //for SEO
  useEffect(() => {
    if (jobreadonly.about_company !== undefined) {
      let descMeta = jobreadonly.about_company
        ?.substring(0, 160)
        .replace(/<[^>]+>/g, "");
      let titleMeta = `${jobreadonly.role_title} at ${
        jobreadonly.campany_name || "Workbrook"
      } - Job Opportunity`;
      document.title = titleMeta;

      if (
        metaAdder('name="description"', descMeta) &&
        metaAdder('property="og:description"', descMeta) &&
        metaAdder('property="og:title"', titleMeta) &&
        metaAdder('property="og:type"', "website") &&
        metaAdder('property="og:url"', window.location.href) &&
        metaAdder('property="twitter:title"', titleMeta) &&
        metaAdder('property="twitter:description"', descMeta) &&
        metaAdder('property="twitter:card"', "summary_large_image")
      ) {
        console.log("Set setHasUpdatedMetaTag to TRUE ");
        setHasUpdatedMetaTag(true);
      }
    }
  }, [jobreadonly]);

  useEffect(() => {
    let path = window.location.pathname;
    let jobID = path.split("/")[2];
    let currenturl = window.location.href;
    let totalURL = currenturl.replace("job-lists-details", "home");

    const isMobileDevice = () => false;
    // const isMobileDevice = () =>
    //   /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    if (isMobileDevice()) {
      setApplyLink(`workbrook://job-lists-details/${jobID}/apply/${refLink}`);
    } else {
      setApplyLink(totalURL);
    }
    setOriginalURL(currenturl);

    Promise.resolve(getJobNoAuthAction(dispatch, jobID))
      .then(() => {
        console.log("Job details fetched successfully.");
      })
      .catch((error) => {
        console.error("Failed to fetch job details:", error);
      });
  }, [dispatch, refLink]);

  const metaAdder = (queryProperty, value) => {
    // Get an element if it exists already
    let element = document.querySelector(`meta[${queryProperty}]`);

    // Check if the element exists
    if (element) {
      // If it does just change the content of the element
      element.setAttribute("content", value);
      return false;
    } else {
      // It doesn't exist so lets make a HTML element string with the info we want
      element = `<meta ${queryProperty} content="${value}" />`;

      // And insert it into the head
      document.head.insertAdjacentHTML("beforeend", element);
      console.log("Added Meta for " + queryProperty);

      return true;
    }
  };

  return (
    <div>
      {hasUpdatedMetaTag ? (
        <div>
          <div id="main-content" className="blog-page">
            <div className="container">
              <div className="row clearfix">
                <div className="col-lg-8 col-md-12 left-box">
                  <div className="card single_post">
                    <div className="body">
                      <div className="img-post">
                        {/* 
                              <img class="d-block img-fluid" src="https://via.placeholder.com/800x280/87CEFA/000000" alt="First slide" />
                        */}
                      </div>
                      <h3>{jobreadonly.role_title}</h3>
                      {/** Details Content Starts */}
                      <div className="mt-5x pt-5">
                        <div>
                          <a href={applyLink} className="applynowClass">
                            Apply Now
                          </a>
                        </div>
                        <div className="mt-5">
                          <div>
                            <h5>
                              <strong>Reports To</strong>
                            </h5>
                            <p>{jobreadonly.reports_to}</p>
                          </div>

                          <div>
                            <br />
                            <h5>
                              <strong>About the company</strong>
                            </h5>
                            <br />
                            <p>
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: jobreadonly.about_company,
                                }}
                              ></span>
                            </p>
                          </div>

                          <div>
                            <br />
                            <h5>Applicants Benefits</h5>
                            <p>salary</p>
                          </div>
                          {/* <div>
                            <h5>Salary</h5>
                            <p>{jobreadonly.salary}</p>
                          </div> */}
                          <div>
                            <h5>Skills Required</h5>
                            <ul className="d-flex flex-wrap mt-3">
                              {jobreadonly &&
                                jobreadonly.skills_required &&
                                jobreadonly.skills_required.map(
                                  (item, index) => {
                                    return (
                                      <li
                                        key={index}
                                        className="mr-2 py-1 px-2 mt-1 outlined"
                                      >
                                        {item}
                                      </li>
                                    );
                                  }
                                )}
                            </ul>
                          </div>
                        </div>
                      </div>
                      {/** End Details Contents */}
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-12 right-box">
                  <div className="card">
                    <div className="header text-center">
                      <a href={applyLink} className="applynowClass">
                        Apply to this Job
                      </a>
                    </div>

                    <div
                      className="mx-auto w-75 w-100 mt-4"
                      style={{ textAlign: "center" }}
                    >
                      <h6>Share to Social Network</h6>
                      <div>
                        <FacebookShareButton
                          url={originalURL}
                          quote={jobreadonly.role_title}
                          className="mr-2"
                          hashtag="#workbrook #job"
                        >
                          <FacebookIcon size={32} round />
                        </FacebookShareButton>

                        <TwitterShareButton
                          url={originalURL}
                          title={jobreadonly.role_title}
                          className="mr-2"
                          hashtags={hashtags}
                        >
                          <TwitterIcon size={32} round />
                        </TwitterShareButton>

                        <LinkedinShareButton url={originalURL} className="mr-2">
                          <LinkedinIcon size={32} round />
                        </LinkedinShareButton>

                        <WhatsappShareButton
                          url={`${jobreadonly.role_title}  ${originalURL}`}
                          className="mr-2"
                        >
                          <WhatsappIcon size={32} round />
                        </WhatsappShareButton>

                        <div style={{ marginTop: "5%" }}></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <script type="application/ld+json">{structuredJSON}</script>
        </div>
      ) : (
        <div>Loading...</div>
      )}
    </div>
  );
};

export default JobListPublicDetails;
